const CATEGORY_KEYS = {
  Forex: 'symbol.forex',
  Cryptocurrencies: 'symbol.cryptocurrencies',
  Commodities: 'symbol.commodities',
  ETFs: 'symbol.etfs',
  Stocks: 'symbol.stocks',
  Shares: 'symbol.shares',
  Energies: 'symbol.energies',
  Indices: 'symbol.indices',
};

export function translateCategoryName(name, t) {
  const key = CATEGORY_KEYS[name];
  return key ? t(key) : name;
}
